/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Archived
 */
export interface Archived {}

/**
 * Check if a given object implements the Archived interface.
 */
export function instanceOfArchived(value: object): boolean {
    return true;
}

export function ArchivedFromJSON(json: any): Archived {
    return ArchivedFromJSONTyped(json, false);
}

export function ArchivedFromJSONTyped(json: any, ignoreDiscriminator: boolean): Archived {
    return json;
}

export function ArchivedToJSON(value?: Archived | null): any {
    return value;
}
